import { doAttention } from '@/attention';
export function flash(el, duration = undefined, options = {}) {
    return doAttention(el, 'flash', duration, options);
}
//# sourceMappingURL=flash.js.map